export { default } from './ModalSettingManualActivation';
